module.exports = __webpack_public_path__ + "img/guillaume-brunet.bb87bfa1.png";